import {
  LightMode,
  ModalContent,
  ModalContentProps,
  forwardRef,
} from '@chakra-ui/react'
import { ElementRef } from 'react'

/** Light shell + tokens on a paper dialog while the app is in dark mode. */
export const LightModeModalContent = forwardRef<
  ElementRef<typeof ModalContent>,
  ModalContentProps
>((props, ref) => (
  <LightMode>
    <ModalContent ref={ref} {...props} />
  </LightMode>
))

LightModeModalContent.displayName = 'LightModeModalContent'
